
    
    <div class="container">
        <div class="toolbar">
            <button (click)="exportFile()">Xuất file</button>
        </div>
    
        <div class="search-bar">
            <input type="text" [(ngModel)]="searchKeyword" placeholder="Nhập từ khóa tìm kiếm..." (input)="onSearch()">
            <button (click)="onSearch()">Tìm kiếm</button>
        </div>
    
        <div class="action-bar">
            <select [(ngModel)]="selectedAction">
                <option value="">Hành động</option>
                <option value="add">Thêm</option>
                <option value="edit">Sửa</option>
                <option value="delete">Xóa</option>
            </select>
            <button (click)="performAction()">
                <span class="icon"><i class="fas fa-pencil-alt"></i></span> Thực hiện
            </button>
            <span id="record-status">{{ selectedCount }} của {{ totalCount }} được chọn</span>
        </div>
    
        <div id="action-message" class="message" *ngIf="actionMessage">
            {{ actionMessage }}
        </div>
    

        <div *ngIf="selectedAction === 'add' || selectedAction === 'edit'" class="input-fields">
            <div>
                <label for="name">Tên:</label>
                <input id="name" type="text" [(ngModel)]="newName" placeholder="Nhập tên bệnh lý">
            </div>
            <div>
                <label for="details">Chi tiết:</label>
                <input id="details" type="text" [(ngModel)]="newDetails" placeholder="Nhập chi tiết bệnh lý">
            </div>
        </div>
    
        <div class="table-container">
            <table id="data-table">
                <thead>
                    <tr>
                        <th><input type="checkbox" [(ngModel)]="selectAll" (change)="toggleSelectAll()"></th>
                        <th>ID</th>
                        <th>Tên</th>
                        <th>Chi tiết</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of displayedRows; let i = index">
                        <td><input type="checkbox" [(ngModel)]="row.selected" (change)="updateSelectedCount()"></td>
                        <td>{{ row.id }}</td>
                        <td (click)="startEditing(row)">{{ row.name }}</td>
                        <td>{{ row.details }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    

        <div class="pagination">
            <button (click)="prevPage()" [disabled]="currentPage === 1">Prev</button>
            <span>{{ currentPage }} / {{ totalPages }}</span>
            <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
        </div>

        <div class="feedback-section">
            <h3 class="feedback-title">Góp ý của bạn</h3>
            <p class="feedback-desc">Chúng tôi luôn mong nhận được góp ý từ bạn để cải thiện hệ thống:</p>
            <textarea
                [(ngModel)]="userFeedback"
                class="feedback-input"
                placeholder="Nhập ý kiến của bạn..."
                rows="4"
            ></textarea>
            <div class="feedback-actions">
                <button class="feedback-btn" (click)="submitFeedback()">Gửi góp ý</button>
            </div>
            <div *ngIf="feedbackMessage" class="feedback-message">
                {{ feedbackMessage }}
            </div>
        </div>
        
    </div>
    
    